"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiObjectSelect = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var click_outside_1 = require("../../hooks/click-outside");
var debounced_callback_1 = require("../../hooks/debounced-callback");
var colors_1 = require("../../theme/colors");
var icon_button_1 = require("../icon-button");
var input_1 = require("../input");
var padding_1 = require("../padding");
var spacing_1 = require("../spacing");
var stack_1 = require("../stack");
var search_result_list_1 = require("./components/search-result-list");
function MultiObjectSelect(props) {
    var searchFetch = props.searchFetch, data = props.data, formatter = props.formatter, _a = props.debounce, debounce = _a === void 0 ? 100 : _a, handleResults = props.handleResults, handleSearch = props.handleSearch, hideNotFound = props.hideNotFound, initialQuery = props.initialQuery, _b = props.minSearchLength, minSearchLength = _b === void 0 ? 0 : _b, onSelectValue = props.onSelectValue, onRemoveValue = props.onRemoveValue, placeholder = props.placeholder, testId = props.testId, renderOptions = props.renderOptions, renderSelected = props.renderSelected, selectedItems = props.selectedItems, footerAction = props.footerAction, getRemoveIconType = props.getRemoveIconType, _c = props.showOptionsOnEmpty, showOptionsOnEmpty = _c === void 0 ? false : _c, disabledHoverText = props.disabledHoverText;
    var _d = (0, react_1.useState)(initialQuery !== null && initialQuery !== void 0 ? initialQuery : ''), selectedSearchQuery = _d[0], setSelectedSearchQuery = _d[1];
    var _e = (0, react_1.useState)(initialQuery !== null && initialQuery !== void 0 ? initialQuery : ''), search = _e[0], setSearch = _e[1];
    var _f = (0, react_1.useState)(false), searchFocused = _f[0], setSearchFocused = _f[1];
    var listRef = (0, react_1.useRef)();
    var shouldSearchFetch = (search && search.length >= minSearchLength) || showOptionsOnEmpty;
    var memoedSearch = react_1.default.useMemo(function () { return function (value) {
        searchFetch(value);
    }; }, [searchFetch]);
    var debouncedSearchFetch = (0, debounced_callback_1.useDebouncedCallback)(memoedSearch, debounce);
    (0, click_outside_1.useOnClickOutside)(listRef, function () {
        if (!searchFocused) {
            return;
        }
        setSearchFocused(false);
    });
    (0, react_1.useEffect)(function () {
        if (debouncedSearchFetch && shouldSearchFetch) {
            debouncedSearchFetch(search);
        }
    }, [search, debouncedSearchFetch, shouldSearchFetch]);
    if (handleResults) {
        handleResults(data);
    }
    function handleSelect(value) {
        onSelectValue(value);
        setSearch('');
        setSearchFocused(false);
    }
    function handleRemove(option) {
        if (onRemoveValue) {
            onRemoveValue(option);
            return;
        }
        var selectedNew = (0, tslib_1.__assign)({}, selectedItems);
        delete selectedNew[option.key];
        onSelectValue(selectedNew);
    }
    function onChange(value) {
        setSelectedSearchQuery(null);
        setSearch(value);
        if (handleSearch) {
            handleSearch(value);
        }
    }
    var selectedList = selectedItems &&
        Object.entries(selectedItems).map(function (_a) {
            var _objectKey = _a[0], value = _a[1];
            var Component = renderSelected ? renderSelected(value) : renderOptions(value);
            var option = formatter(value);
            var iconType = typeof getRemoveIconType === 'function' ? getRemoveIconType(value) : getRemoveIconType || 'close';
            return (react_1.default.createElement(ListItem, { key: option.key },
                Component,
                react_1.default.createElement(padding_1.Padding, { x: 24, y: 24 },
                    react_1.default.createElement(icon_button_1.IconButton, { type: iconType, onClick: function () { return handleRemove(option); } }))));
        });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledAutoCompleteSearch, { ref: listRef },
            react_1.default.createElement(input_1.Input, { testId: testId, type: "search-new", placeholder: placeholder || 'Filter by keyword...', onChange: onChange, onFocus: function () { return setSearchFocused(true); }, value: selectedSearchQuery || search || '' }),
            (search || showOptionsOnEmpty) && searchFocused && data && (!hideNotFound || data.length > 0) && (react_1.default.createElement(search_result_list_1.SearchResultList, { renderOptions: renderOptions, formatter: formatter, onSelect: handleSelect, results: data, selectedItems: selectedItems, footerAction: footerAction, disabledHoverText: disabledHoverText }))),
        selectedList.length ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(spacing_1.Spacing, { height: 8 }),
            react_1.default.createElement(stack_1.Stack, { direction: "vertical", gap: 12 }, selectedList))) : null));
}
exports.MultiObjectSelect = MultiObjectSelect;
var hoverStyles = "\n  &:hover {\n    background-color: ".concat(colors_1.colors.steel[50], ";\n    cursor: pointer;\n  }\n");
var ListItem = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: flex;\n  justify-content: space-between;\n  ", "\n  background: #fafbfc;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  ", "\n  background: #fafbfc;\n"])), hoverStyles);
var StyledAutoCompleteSearch = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map